module.exports = __webpack_public_path__ + "static/media/17.ad19b47d.png";